define(
    'providers/dataprovider.accesscontrol',[
        "services/config"
    ],
    function(config) {

        var folders = (function() {
            var actions = {
                none: 0,
                rename: 1,
                add: 2,
                remove: 4,
                addDocument: 8
            };

            function getAllowedActions(folderId) {
                var deferred = $.Deferred();
                amplify.request({
                    resourceId: "folder-actions",
                    data: { folderId: folderId },
                    success: function(result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function(result, statusCode) { deferred.reject(result, statusCode); }
                });
                return deferred.promise();
            }

            return {
                actions: actions,
                getAllowedActions: getAllowedActions
            };

        }());

        var deletedDocuments = (function() {
            var actions = {
                none: 0,
                showAllDeletedDocuments: 1
            };

            function getAllowedActions() {
                var deferred = $.Deferred();
                amplify.request({
                    resourceId: "deleted-document-actions",
                    data: null,
                    success: function(result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function(result, statusCode) { deferred.reject(result, statusCode); }
                });
                return deferred.promise();
            }

            return {
                actions: actions,
                getAllowedActions: getAllowedActions
            };
        }());

        var documents = (function() {
            var actions = {
                none: 0,
                open: 1,
                openWith: 2,
                newFromTemplate: 4,
                copyDocument: 8,
                share: 16,
                saveNewVersion: 32,
                modifyField: 64,
                edit: 128,
                replaceFile: 256,
                checkOut: 512,
                cancelCheckOut: 1024,
                'delete': 2048,
                saveOnly: 10,
                readPublishedOnly: 20,
                readOnly: 30,
                isItemVisible: 40,
                fullAccess: 50,
                fullControl:60
            };

            function getAllowedActions() {
                var deferred = $.Deferred();
                amplify.request({
                    resourceId: "document-actions",
                    data: null,
                    success: function(result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function(result, statusCode) { deferred.reject(result, statusCode); }
                });
                return deferred.promise();
            }

            return {
                actions: actions,
                getAllowedActions: getAllowedActions,
            };
        }());

        init();

        return {
            documents: documents,
            deletedDocuments: deletedDocuments,
            folders: folders
        };

        //#region Internal Methods

        function init() {

            amplify.request.define("document-actions", "ajax", {
                url: getUrl("documents/actions"),
                dataType: "json",
                type: "GET",
            });

            amplify.request.define("folder-actions", "ajax", {
                url: getUrl("folders/{folderId}/actions"),
                dataType: "json",
                type: "GET",
            });

            amplify.request.define("deleted-document-actions", "ajax", {
                url: getUrl("documents/deleted/actions"),
                dataType: "json",
                type: "GET",
            });
        }

        function getUrl(action) {
            return config.webApiUrl + "access-control/" + action;
        }

        //#endregion
    }
);
